import { QUESTION_TYPES } from "../../constants";

function useQuestionTypeLabel(type, subtype) {
  if (type === "datetime") {
    if (subtype === "date_only") return "Date";
    if (subtype === "time_only") return "Time";
    if (subtype === "datetime") return "Date and time";
  }

  if (type === "radio" || type === "checkbox") {
    return "Choice";
  }

  if (type === "text") {
    if (subtype === "email") return "Email";
    if (subtype === "phone") return "Phone";
    if (subtype === "calculation") return "Calculation";
  }

  if (type === "file_upload") {
    return QUESTION_TYPES[type]?.subtypes?.find((item) => item.id === subtype)
      ?.name;
  }

  return QUESTION_TYPES[type]?.name;
}

export default useQuestionTypeLabel;
